import { Component, Injector, OnInit } from '@angular/core';
import { ComponentContextService, ComponentBase } from 'tnx-shared';
import { TemplateTypes } from 'tnx-admin-service/templateinstance/models';
import { ExcelService } from 'tnx-admin-service/excel/services';
@Component({
    selector: 'excel',
    templateUrl: './excel.component.html',
    styleUrls: ['./excel.component.scss'],
    providers: [ComponentContextService],
})
export class ExcelComponent extends ComponentBase implements OnInit {
    templateType = TemplateTypes.cxExcel;

    constructor(
        protected _injector: Injector,
        protected _excelService: ExcelService,
    ) {
        super(_injector);
    }

    ngOnInit() {
    }
}

